import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Styles from "../../styles/session/viewsession.module.scss";
import Navbar from "../../components/Navbar";
import { adminRoutes } from "../../routers/AdminRouters";
import Edit from "../../assets/exersise/pencil-edit.png";
import { getSessionById } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const ViewSession = () => {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const [sessionDetails, setSessionDetails] = useState({
    name: "",
    code: "",
    details: "",
    thankyou: "",
    warmup:"",
  });

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await getSessionById(sessionId);

        if (response) {
          setSessionDetails({
            name: response.name,
            code: response.code,
            details: response.details,
            thankyou: response.thankyou,
            warmup:response.warmupTime,
          });
        }
      } catch (error) {
        console.error("Error fetching session details:", error);
      }
    };

    if (sessionId) {
      fetchSession();
    }
  }, [sessionId]);
  const handleEdit = (sessionId) => {
    navigate(`${adminRoutes.editSession.replace(":sessionId", sessionId)}`);
  };

  const handleBack = async () => {
    navigate(adminRoutes.listSession);
  };

  return (
    <>
      <Navbar />
      <div
        onClick={handleMainContainerClick}
        className={Styles.viewsession_main}
      >
        <div className={Styles.viewsession_main_parent}>
          <div className={Styles.viewsession_container}>
            <h2>
              <Link to={adminRoutes.dashboard} className={Styles.dark}>
                HOME /
              </Link>{" "}
              <Link to={adminRoutes.listSession} className={Styles.white}>
                ALL SESSIONS /
              </Link>{" "}
              <span className={Styles.orange}>VIEW SESSION</span>
            </h2>
          </div>
          <div className={Styles.container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h3>SESSIONS &nbsp;DETAILS</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <div
                  className={Styles.create_new_session}
                  onClick={() => handleEdit(sessionId)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={Edit}
                    alt="Duplicate Icon"
                    className={Styles.icon}
                  />
                  Edit
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
            <div className={Styles.header}>
              <div className={Styles.session_code}>
                <p>Session Code</p>

                <h4>{sessionDetails.code}</h4>
              </div>
              <div className={Styles.session_name}>
                <p>Session Name</p>
                <h4>{sessionDetails.name}</h4>
              </div>
              <div className={Styles.session_name}>
                <p>Warmup Time</p>
                <h4>{secondsToHhmmss(sessionDetails.warmup)}</h4>
              </div>
            </div>

            <div className={Styles.details_section}>
              <div className={Styles.details_column}>
                <div className={Styles.seperator}>
                  <h3 className={Styles.title}>SECOND PAGE PREVIEW DETAILS</h3>{" "}
                  &nbsp;
                  <hr className={Styles.linesep} />
                </div>
                <div
                  className={Styles.rich_text_content}
                  dangerouslySetInnerHTML={{ __html: sessionDetails.details }}
                ></div>
              </div>
              <div className={Styles.details_column}>
                <div className={Styles.seperator}>
                  <h3 className={Styles.title}>
                    THANK YOU PAGE PREVIEW DETAILS
                  </h3>{" "}
                  &nbsp;
                  <hr className={Styles.linesep} />
                </div>
                <div
                  className={Styles.rich_text_content}
                  dangerouslySetInnerHTML={{ __html: sessionDetails.thankyou }}
                ></div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
            <div>
              <button onClick={handleBack} className={Styles.button_container}>
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSession;
